module.exports = "/templates/reportviewer.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/reportviewer.html
// module id = 456
// module chunks = 0